import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiGetSmsListHistoryOptions, filterKey, SmsScheduleType } from '@models/reseller/sms-history-detail';
import { ApiGetSubaccounts, Subaccount } from '@models/subaccount/subaccount';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SmsHistoryService } from '@services/sms-history.service';
import { SmsService } from '@services/sms.service';
import { SubaccountService } from '@services/subaccount.service';
import { AtlasGridOptions } from '@ui/components/atlas-grid/altas-grid-options.model';
import { AtlasGridComponent } from '@ui/components/atlas-grid/atlas-grid.component';
import { ButtonGroupRendererComponent } from '@ui/components/atlas-grid/renderer/buttongroup-renderer.component';
import { AtlasGridHtmlRendererComponent } from '@ui/components/atlas-grid/renderer/html-renderer.component';
import { SmsDetailRenderComponent } from '@ui/components/atlas-grid/renderer/sms-detail-render/sms-detail-render.component';
import { creditsTypeIcon } from '@utils/constants';
import { formateDateTimeWithSeconds } from '@utils/utils';
import { Subject } from 'rxjs';
import { debounceTime, finalize } from 'rxjs/operators';
import { HistoryDetailModalComponent } from 'src/app/views/reseller/reseller-history/history-modal-detail/history-detail-modal.component';
import { LoaderService } from '@services/loader.service';

@Component({
  selector: 'wsb-sms-scheduled',
  templateUrl: './sms-scheduled.component.html',
  styleUrls: ['./sms-scheduled.component.scss'],
  animations: [
    trigger('gridIsLoaded', [
      state('hide', style({ opacity: 0 })),
      state('show', style({ opacity: 1 })),
      transition('hide => show', animate('150ms', style({ opacity: 1 }))),
      transition('show => hide', animate('150ms', style({ opacity: 0 })))
    ])
  ],
  standalone: false
})
export class SmsScheduledComponent implements OnInit, AfterViewInit {
  @ViewChild('grid') grid: AtlasGridComponent;
  @ViewChild('modalExportSmsList') modalExportSmsList;
  @ViewChild('modalSuccessExport') modalSuccessExport;
  @ViewChild('modalConfirmDelete') modalConfirmDelete;
  @ViewChild('modalConfirmEdit') modalConfirmEdit;

  modalConfirmEditModal: NgbModalRef;
  modalConfirmDeleteModal: NgbModalRef;

  modalSuccessExportModal: NgbModalRef;
  modalExportSmsListModal: NgbModalRef;

  fc: UntypedFormControl = new UntypedFormControl('', Validators.required);
  editConfirmText;
  apiGetSmsListHistoryOptions = new ApiGetSmsListHistoryOptions();

  aggregableByCampain;

  private search: Subject<string> = new Subject();
  gridApi;
  gridColumnApi;
  tableLoading: boolean;
  tableHistoryGridOptions = null;
  tableColumnsDefs: any = [];
  paginationPageSize = 10;
  tableHistoryData;
  components = {
    smsDetailRederer: SmsDetailRenderComponent,
    buttonGroupRenderer: ButtonGroupRendererComponent,
    htmlRenderer: AtlasGridHtmlRendererComponent
  };
  scrollPageSubs = 1;
  subaccounts: Array<Subaccount> = [];

  filter;
  today = new Date();

  dateFrom;
  dateTo;
  credits: any[];
  typeLabel;
  idMessage;

  labels = [
    { id: 'SENDER', label: 'sender_sender' },
    { id: 'SENDING-METHOD', label: 'sms_detail_sentfrom' }
  ];
  gridAnimationState = 'hide';
  constructor(
    private smsHistoryService: SmsHistoryService,
    private smsService: SmsService,
    private modalService: NgbModal,
    private router: Router,
    private loaderService: LoaderService,
    private subaccountService: SubaccountService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.translateLables();

    this.getCreditsType();

    this.defineTable();

    this.gridOptionDefinition();
    //
  }

  ngAfterViewInit(): void {
    this.grid.dataIsLoaded.subscribe(() => {
      this.gridAnimationState = 'show';
    });
    // this.grid.refresh();
  }

  translateLables() {
    this.translateService.get('sms_editscheduled_confirm_text').subscribe((translatedLabel: string) => {
      this.editConfirmText = translatedLabel.replace(/<br\/>/g, '\n');
    });

    this.labels.forEach(label => {
      this.translateService.get(label.label).subscribe(translatedLabel => (label.label = translatedLabel));
    });
  }

  getCreditsType() {
    this.smsService.getMessageTypes().subscribe(data => {
      this.credits = data.data.map(x => {
        return {
          value: x.id,
          icon: creditsTypeIcon[x.id],
          title: x.label
        };
      });
    });
  }

  getSubaccountList() {
    this.search.pipe(debounceTime(250)).subscribe(filter => {
      const body: ApiGetSubaccounts = {
        login: filter
      } as ApiGetSubaccounts;

      this.subaccountService.getSubaccounts(null, null, null, null, body).subscribe(subs => {
        this.subaccounts = subs.data;
      });
    });
  }

  onSearch($event) {
    this.search.next($event.term);
  }

  defineTable() {
    this.tableColumnsDefs = [
      {
        headerNameTranslate: 'common_title',
        field: 'campaignName',
        colPrefKey: 'campaignName',
        cellRenderer: 'htmlRenderer',
        cellRendererParams: {
          content: params => {
            if (params && params.data) {
              return (
                '<div class="d-flex title"> <div class="overflow-h"> <div class="campaignName title-overflow color-primary">' +
                params.data.campaignName +
                '</div> </div> <span > ' +
                this.labels[0].label +
                ' ' +
                params.data.sender +
                '</span> <span > ' +
                this.labels[1].label +
                ': ' +
                params.data.sentFrom +
                '</span> </div>'
              );
            } else {
              return '';
            }
          }
        },
        width: 180
      },
      {
        headerNameTranslate: 'common_text',
        field: 'message',
        colPrefKey: 'message',
        cellRenderer: 'htmlRenderer',
        width: 300,
        cellRendererParams: {
          content: params => {
            if (params && params.data) {
              const label = this.translateService.instant('encrypted_label');
              return (
                '<div style="overflow: hidden;"> <div class="message-overflow">' +
                (params.data.message === 'xxx' ? label : params.data.message) +
                '</div></div>'
              );
            } else {
              return '';
            }
          }
        },
        sortable: false
      },
      {
        headerNameTranslate: 'common_status',
        field: 'status',
        sortable: false,
        colPrefKey: 'status',
        suppressCellFocus: true,
        width: 125,
        cellRenderer: 'htmlRenderer',
        cellRendererParams: {
          content: params => {
            if (params && params.data) {
              let badgeLabel;
              this.translateService.get('sms_detail_sendtype_4').subscribe(label => {
                badgeLabel = label;
              });
              return '<span class="badge badge-scheduled">' + badgeLabel + '</span>';
            } else {
              return '';
            }
          }
        }
      },
      {
        headerNameTranslate: 'common_number_recipient',
        field: 'recipients',
        sortable: false,
        width: 120
      },
      {
        headerNameTranslate: 'common_data_added',
        field: 'createTime',
        sortable: false,
        width: 110,
        cellRenderer: 'htmlRenderer',
        cellRendererParams: {
          content: params => {
            if (params && params.data) {
              const dateTime = formateDateTimeWithSeconds(params.data.createTime).split(' ');
              const date = dateTime[0];
              const time = dateTime[2] ? dateTime[1] + ' ' + dateTime[2] : dateTime[1];
              return '<div class="dateTime"><span>' + date + '</span> <span>' + time + '</span></div>';
            }
            return '';
          }
        }
      },
      {
        headerNameTranslate: 'common_data_sent',
        field: 'dateForSend',
        cellRenderer: 'htmlRenderer',
        sortable: false,
        sort: 'desc',
        width: 110,
        cellRendererParams: {
          content: params => {
            if (params && params.data) {
              const dateTime = formateDateTimeWithSeconds(params.data.dateForSend).split(' ');
              const date = dateTime[0];
              const time = dateTime[2] ? dateTime[1] + ' ' + dateTime[2] : dateTime[1];
              return '<div class="dateTime"><span>' + date + '</span> <span>' + time + '</span></div>';
            }
            return '';
          }
        }
      },
      {
        headerNameTranslate: 'common_type',
        field: 'idMessageType',
        cellRenderer: 'htmlRenderer',
        cellRendererParams: {
          content: params => {
            if (params && params.data) {
              const icon = this.credits.filter(type => type.value === params.data.idMessageType);
              return '<div class="type"><img class="ml-2 info-icon" src="' + icon[0]?.icon + '" alt="" /> </div>';
            } else {
              return '';
            }
          }
        },
        width: 110,
        sortable: false
      },
      // {
      //   headerNameTranslate: 'sender_sender',
      //   field: 'sender',
      //   sortable: false
      // },
      // {
      //   headerNameTranslate: 'list_sms_tablefield_sentfrom',
      //   field: 'sentFrom',
      //   sortable: false
      // },
      {
        headerNameTranslate: 'common_actions',
        suppressCellFocus: true,
        cellRenderer: 'buttonGroupRenderer',
        cellRendererParams: {
          items: [
            {
              onClick: e => {
                this.smsHistoryService.data = e;
                this.openModalConfirmEdit(e.idMessage, e.scheduleType);
              },
              label: 'common_edit'
            },
            {
              onClick: e => this.openModalConfirmDelete(e.idMessage, e.scheduleType),
              label: 'common_delete'
            }
          ]
        },

        cellClass: ['button-group', 'text-end'],
        maxWidth: 82,
        field: '__actions'
      }
    ];
  }

  gridOptionDefinition() {
    const that = this;
    this.tableHistoryGridOptions = AtlasGridOptions.deserialize({
      pagination: true,
      paginationPageSize: this.paginationPageSize,
      loadFunction: this.reloadList.bind(that),
      noRowsOverlayOptions: {
        message: ''
      },
      rowHeight: 110
    });
  }

  loadData() {
    this.grid.filtersModel[filterKey.period] = {
      label: 'timefilter_dates_thismonth',
      value: 'thismonth',
      translate: true
    };
    this.grid.refresh();
  }

  reloadList(startRow?, endRow?, sort?) {
    this.loaderService.show();
    return this.smsHistoryService
      .getSmsScheduledList(
        SmsScheduleType.scheduled,
        1 + startRow / (endRow - startRow),
        endRow - startRow,
        sort && sort.length ? sort[0].colId : null,
        sort && sort.length ? (sort[0].sort === 'desc' ? 'd' : 'a') : null
      )
      .pipe(finalize(() => this.loaderService.hide()));
  }

  openHistoryDetailModal(idMessage, scheduleType) {
    const options: NgbModalOptions = {
      size: 'lg'
    };
    const landingPageModal = this.modalService.open(HistoryDetailModalComponent, options);
    (landingPageModal.componentInstance as HistoryDetailModalComponent).idMessage = idMessage;
    (landingPageModal.componentInstance as HistoryDetailModalComponent).hidden = true;
    (landingPageModal.componentInstance as HistoryDetailModalComponent).scheduled = true;
    (landingPageModal.componentInstance as HistoryDetailModalComponent).scheduleType = scheduleType;
  }

  openModalConfirmDelete(idMessage, scheduledType): void {
    this.modalConfirmDeleteModal = this.modalService.open(this.modalConfirmDelete);
    this.modalConfirmDeleteModal.result.then(
      result => {
        this.smsHistoryService.deleteScheduledSms(idMessage, scheduledType).subscribe(() => {
          this.grid.refresh();
        });
        this.modalService.dismissAll();
      },
      reason => {
        this.modalService.dismissAll();
      }
    );
  }

  openModalConfirmEdit(idMessage, scheduledType): void {
    this.modalConfirmEditModal = this.modalService.open(this.modalConfirmEdit);
    this.modalConfirmEditModal.result.then(
      result => {
        this.smsHistoryService.deleteScheduledSms(idMessage, scheduledType).subscribe(() => {
          this.router.navigate(['/sms/send'], { queryParams: { edit: true } });
        });
        this.modalService.dismissAll();
      },
      reason => {
        this.modalService.dismissAll();
      }
    );
  }

  closeDelete() {
    this.modalConfirmDeleteModal.close();
  }

  closeEdit() {
    this.modalConfirmEditModal.close();
  }
}
